<script setup lang="ts">
import {
  CustomLink,
  LinkColor,
  LinkIcon,
  LinkIconLocation,
  LinkSize,
  LinkType
} from "@frontiers-vue3/public-pages";

const baseUrl = computed(() => {
  const router = useRequestURL();
  const runtimeConfig = useRuntimeConfig();

  return useGetBaseUrl(router, runtimeConfig);
});
</script>
<template>
  <section class="FeeProgram">
    <div class="FeeProgram__Section">
      <h3 class="FeeProgram__Section__Title">
        Are you aware of Frontiers Institutional Partnerships?
      </h3>
      <p class="FeeProgram__Section__Text">
        The Frontiers Institutional Partnerships program works with hundreds of
        research institutions to financially support their authors when
        publishing open access.
      </p>

      <div class="FeeProgram__Section__Buttons">
        <CustomLink
          :link="{
            text: 'Search for my institution',
            url: `${baseUrl}/about/institutional-partnerships`
          }"
          :size="LinkSize.Medium"
          :color="LinkColor.Maincolor"
          :to="`${baseUrl}/about/institutional-partnerships`"
          :icon="LinkIcon.ChevronRight"
          :icon-location="LinkIconLocation.Right" />
      </div>
    </div>
    <div class="FeeProgram__Divider"></div>
    <div class="FeeProgram__Section">
      <p class="FeeProgram__Section__Text">
        We also provide a support program for authors and institutions with
        insufficient funding. Authors in countries classified by the World Bank
        as low or low-middle income economies will be eligible for discounts to
        their APC.
      </p>

      <div class="FeeProgram__Section__Buttons">
        <CustomLink
          :link="{
            text: 'Apply for fee support',
            url: `https://frontiersin.qualtrics.com/jfe/form/SV_9YqUCmY73k4Gm0u`
          }"
          :size="LinkSize.Medium"
          :color="LinkColor.Maincolor"
          :type="LinkType.OutlineButton" />
        or
        <CustomLink
          :link="{
            text: 'Learn more about the program',
            url: `${baseUrl}/about/fee-policy#fee-discounts`
          }"
          :size="LinkSize.Medium"
          :color="LinkColor.Maincolor"
          :icon="LinkIcon.ChevronRight"
          :icon-location="LinkIconLocation.Right" />
      </div>
    </div>
  </section>
</template>
<style lang="scss">
.FeeProgram {
  padding: 24px;
  background-color: $white;
  border-radius: 8px;

  &__Divider {
    margin: 32px 0;
    width: 100%;
    border-top: solid 1px $grey40;
  }

  &__Section {
    &__Title {
      @include f-18-700;
      margin-top: 0;
      margin-bottom: 8px;
    }

    &__Text {
      @include f-16-300;
      margin-bottom: 24px;
    }

    &__Buttons {
      display: flex;
      align-items: center;
      gap: 16px;

      @media #{$break-xs} {
        flex-direction: column;
      }
    }
  }
}
</style>
